import { useEffect, useRef } from 'react'
import { getLS } from '../../../helper/LocalStorage'

const getAuthFromLS = () => {
	const authLS = getLS('auth')
	const nowUnix = Math.round(new Date().getTime() / 1000)

	if (authLS && typeof authLS === 'object' && nowUnix < authLS.expiration_time) {
		return authLS
	}

	return null
}

// Hook für die Authentifizierung
const useAuth = (LoginHandler, setLoading, auth) => {
	const hasInitialized = useRef(false)

	useEffect(() => {
		if (hasInitialized.current || auth) {
			return
		}

		hasInitialized.current = true
		const authLS = getAuthFromLS()
		if (authLS) {
			LoginHandler(authLS)
		} else {
			setLoading(false)
		}
	}, [LoginHandler, auth, setLoading])
}

export default useAuth
